import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { PAGE_TYPES } from "enums";

const initialState = {
  modalOpen: false,
  mode: PAGE_TYPES.LOGIN,
  albums: [],
  photos: [],
  selectedPhoto: null,
};

const facebookSlice = createSlice({
  name: "facebookSlice",
  initialState,
  reducers: {
    loadAlbumsSuccess(state, { payload }) {
      state.albums = payload;
    },
    loadPhotosSuccess(state, { payload }) {
      state.photos = payload;
    },
    changeModalOpenSuccess(state, { payload }) {
      state.modalOpen = payload;
    },
    changeModeSuccess(state, { payload }) {
      state.mode = payload;
    },
    changeSelectedPhotoSuccess(state, { payload }) {
      state.selectedPhoto = payload;
    },
    clearSelectedPhotoSuccess(state) {
      state.selectedPhoto = null;
    },
    clearPhotosSuccess(state) {
      state.photos = [];
    },
  },
});

export const { actions } = facebookSlice;
export default facebookSlice.reducer;

export const useFacebookActions = () => {
  const dispatch = useDispatch();

  const loadAlbums = (albums) => {
    dispatch(facebookSlice.actions.loadAlbumsSuccess(albums));
  };

  const loadPhotos = (photos) => {
    dispatch(facebookSlice.actions.loadPhotosSuccess(photos));
  };

  const changeMode = (mode) => {
    dispatch(facebookSlice.actions.changeModeSuccess(mode));
  };

  const changeSelectedPhoto = (photo) => {
    dispatch(facebookSlice.actions.changeSelectedPhotoSuccess(photo));
  };

  const changeModalOpen = (isOpen) => {
    dispatch(facebookSlice.actions.changeModalOpenSuccess(isOpen));
  };

  const clearSelectedPhoto = () => {
    dispatch(facebookSlice.actions.clearSelectedPhotoSuccess());
  };

  const clearPhotos = () => {
    dispatch(facebookSlice.actions.clearPhotosSuccess());
  };

  return { loadAlbums, changeMode, loadPhotos, clearPhotos, changeModalOpen, changeSelectedPhoto, clearSelectedPhoto };
};
